import * as R from 'ramda'
import type { SailRefParam } from '@/root/shared-types/selectTicketPage/selectTicket'
import type { CartItemSailParam } from '@/root/shared-providers/BookingCart/types'

const SEPARATOR = ','

/** The legs of `/select-tickets/<packages>/<sailRefIds>`: the n-th package goes with the n-th sail. */
export const parseSailRefParams = (params: { packages: string; sailRefIds: string }): SailRefParam[] => {
  const packages = decodeURIComponent(params.packages).split(SEPARATOR)
  const sailRefIds = decodeURIComponent(params.sailRefIds).split(SEPARATOR)

  return R.zipWith((code, sailRefId): SailRefParam => ({ code, sailRefIds: [sailRefId] }), packages, sailRefIds)
}

/** The sails every ticket of the reservation is booked on. */
export const toCartItemSailParams = (sailParams: SailRefParam[]): CartItemSailParam[] =>
  sailParams.map((leg) => ({ code: leg.code, departureSailId: leg.sailRefIds[0] }))
